import * as React from "react";
import { PlayerProfileCoopInfo } from "./PlayerProfileCoopInfo";
import { PlayerProfileNoCoopInfo } from "./PlayerProfileNoCoopInfo";
import { PlayerProfilePersonalInfo } from "./PlayerProfilePersonalInfo";
export var PlayerProfileInfoArea = React.memo(function (_a) {
    var playerName = _a.playerName, playerLevel = _a.playerLevel, playerIcon = _a.playerIcon, playerId = _a.playerId, coopInfo = _a.coopInfo;
    var renderedCoopInfo = React.createElement(PlayerProfileNoCoopInfo, null);
    if (coopInfo !== undefined) {
        var name = coopInfo.name, level = coopInfo.level, id = coopInfo.id;
        renderedCoopInfo = (React.createElement(PlayerProfileCoopInfo, { playerId: playerId, guildName: name, guildLevel: level, guildId: id }));
    }
    return (React.createElement("div", { className: "flex flex--stacked flex--spaced player-profile__generic-info-container" },
        React.createElement("div", { className: "player-profile__generic-info" },
            React.createElement(PlayerProfilePersonalInfo, { playerId: playerId, playerLevel: playerLevel, playerName: playerName, playerIcon: playerIcon })),
        React.createElement("div", { className: "player-profile__generic-info" }, renderedCoopInfo)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileInfoArea.tsx
// module id = 2875
// module chunks = 3